import { navTabLocked } from '@/features/dashboard/onboarding';
import type { OnboardingState } from '@/features/dashboard/onboarding';

export function billingLinkVisible(
  user: { is_founder?: boolean } | null | undefined,
  onboarding: OnboardingState,
): boolean {
  return Boolean(user?.is_founder) && !navTabLocked('/billing', onboarding);
}
